import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import { Close16 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import { pkg } from '../../settings';
var blockClass = "".concat(pkg.prefix, "--add-select__meta-panel");
var componentName = 'AddSelectMetaPanel';
export var AddSelectMetaPanel = function AddSelectMetaPanel(_ref) {
  var closeIconDescription = _ref.closeIconDescription,
      meta = _ref.meta,
      setDisplayMetaPanel = _ref.setDisplayMetaPanel,
      title = _ref.title;

  var onCloseHandler = function onCloseHandler() {
    setDisplayMetaPanel({});
  };

  return /*#__PURE__*/React.createElement("div", {
    className: blockClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-header")
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(blockClass, "-title")
  }, title), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(blockClass, "-close"),
    renderIcon: Close16,
    iconDescription: closeIconDescription,
    tooltipPosition: "left",
    tooltipAlignment: "center",
    hasIconOnly: true,
    onClick: onCloseHandler,
    kind: "ghost",
    size: "sm"
  })), /*#__PURE__*/isValidElement(meta) ? meta : meta.map(function (entry) {
    return /*#__PURE__*/React.createElement("div", {
      key: entry === null || entry === void 0 ? void 0 : entry.id,
      className: "".concat(blockClass, "-entry")
    }, /*#__PURE__*/React.createElement("p", {
      className: "".concat(blockClass, "-entry-title")
    }, entry === null || entry === void 0 ? void 0 : entry.title), /*#__PURE__*/React.createElement("p", {
      className: "".concat(blockClass, "-entry-body")
    }, entry === null || entry === void 0 ? void 0 : entry.value));
  }));
};
AddSelectMetaPanel.propTypes = {
  closeIconDescription: PropTypes.string.isRequired,
  meta: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string
  })), PropTypes.node]).isRequired,
  setDisplayMetaPanel: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
AddSelectMetaPanel.displayName = componentName;